import { useCallback, useEffect, useState } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import {
  cancelAutoDonateSubscription,
  cancelSubscription,
  getSubscriptions,
} from "../../../redux/state/paymentSlice";

import { blue500 } from "../../../uiKit/assets/colors/colors";
import { Unplug } from "../../../uiKit/assets/svg/unplug";
import CustomButton from "../../../uiKit/Button/CustomButton";
import CustomDialog from "../../../uiKit/CustomDialog/customDialog";
import Title from "../../../uiKit/Title/Title";

const RecurringDonationType = ["Community Recurring", "Auto-Donate"];

const RecurringDonations = () => {
  const dispatch = useDispatch();

  const subscriptions = useSelector((state) => state.payment.subscriptions, shallowEqual);
  const [pageSize, setPageSize] = useState(3);

  useEffect(() => {
    dispatch(getSubscriptions({ page: 1, pageSize }));
  }, [pageSize, dispatch]);

  if (!subscriptions || !subscriptions.items) return null;

  if (!subscriptions.items.length) {
    return <Title text="No recurring donations" fontWeight={400} />;
  }

  return (
    <>
      {subscriptions.items.map((subscription) => {
        if (subscription.type === RecurringDonationType[0])
          return <SubscriptionItem item={subscription} />;
        if (subscription.type === RecurringDonationType[1])
          return <AutoDonateItem item={subscription} />;
        return <></>;
      })}
      {subscriptions.totalNumberOfItems > 3 &&
        (subscriptions.hasNextPage ? (
          <CustomButton title="Show more" isWhite onClick={() => setPageSize((prev) => prev + 2)} />
        ) : (
          <CustomButton
            title="Show less"
            isWhite
            onClick={() =>
              setPageSize((prev) => {
                if (prev > 4) {
                  return prev - 2;
                } else return 3;
              })
            }
          />
        ))}
    </>
  );
};

const SubscriptionItem = ({ item }) => {
  const dispatch = useDispatch();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const cancelHandler = useCallback(() => {
    setConfirmOpen(false);
    if (!item.id) return;
    dispatch(cancelSubscription(item.id))
      .then(unwrapResult)
      .then(() => {
        dispatch(getSubscriptions({ page: 1, pageSize: 3 }));

        //   if (pageSize > 3) {
        //     setPageSize((prev) => prev - 1);
        //     dispatch(getSubscriptions({ page: 1, pageSize: pageSize - 1 }));
        //   } else {
        //     setPageSize(3);
        //     dispatch(getSubscriptions({ page: 1, pageSize: 3 }));
        //   }
      })
      .catch(({ title }) => toast.info(title));
  }, [item?.id, dispatch]);

  if (!item) return <></>;
  return (
    <div className="subscriptionItem" key={item.id}>
      <Title text={item.community.name} fontSize={16} style={{ marginBottom: "8px" }} />
      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "16px", marginBottom: "12px" }}>
          <Title text={`Recurring:`} fontWeight={400} style={{ marginBottom: "8px" }} />
          <Title text={`Amount:`} fontWeight={400} />
        </div>
        <div>
          <Title text={item.recurring} fontWeight={400} style={{ marginBottom: "8px" }} />
          <Title text={`$${item.amount.toLocaleString()}`} fontWeight={400} />
        </div>
      </div>

      <Title
        text="Cancel"
        fontWeight={400}
        color={blue500}
        onClick={() => setConfirmOpen(true)}
        style={{
          cursor: "pointer",
          width: "100px",
        }}
      />
      <CustomDialog
        confirmOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        Image={Unplug}
        mainButtonTitle="Confirm"
        mainButtonAction={cancelHandler}
        secondButton={true}
        title={`You are going to cancel recurring payment for ${item.community.name} community`}
        secondDescription="Confirm your action, please"
      />
    </div>
  );
};

const AutoDonateItem = ({ item }) => {
  const dispatch = useDispatch();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const cancelHandler = useCallback(() => {
    if (!item.id) return;
    setConfirmOpen(false);
    dispatch(cancelAutoDonateSubscription(item.id))
      .then(unwrapResult)
      .then(() => {
        dispatch(getSubscriptions({ page: 1, pageSize: 3 }));

        //   if (pageSize > 3) {
        //     setPageSize((prev) => prev - 1);
        //     dispatch(getSubscriptions({ page: 1, pageSize: pageSize - 1 }));
        //   } else {
        //     setPageSize(3);
        //     dispatch(getSubscriptions({ page: 1, pageSize: 3 }));
        //   }
      })
      .catch(({ title }) => toast.info(title));
  }, [item?.id, dispatch]);

  if (!item) return <></>;
  return (
    <div className="subscriptionItem" key={item.id}>
      <Title text={item.target} fontSize={16} style={{ marginBottom: "8px" }} />
      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "16px", marginBottom: "12px" }}>
          <Title text={`Recurring:`} fontWeight={400} style={{ marginBottom: "8px" }} />
          <Title text={`Amount:`} fontWeight={400} />
        </div>
        <div>
          <Title text={item.recurring} fontWeight={400} style={{ marginBottom: "8px" }} />
          <Title text={`$${item.amount.toLocaleString()}`} fontWeight={400} />
        </div>
      </div>

      <Title
        text="Cancel"
        fontWeight={400}
        color={blue500}
        onClick={() => setConfirmOpen(true)}
        style={{
          cursor: "pointer",
          width: "100px",
        }}
      />
      <CustomDialog
        confirmOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        Image={Unplug}
        mainButtonTitle="Confirm"
        mainButtonAction={cancelHandler}
        secondButton={true}
        title={`You are going to cancel recurring payment for ${item.target}`}
        secondDescription="Confirm your action, please"
      />
    </div>
  );
};

export default RecurringDonations;
